import { useToasts } from "react-toast-notifications";

const useToast = () => {
  const { addToast } = useToasts();

  const successToast = (message) => {
    return addToast(message, { appearance: "success" });
  };

  const errorToast = (message) => {
    return addToast(message, { appearance: "error" });
  };

  const warningToast = (message) => {
    return addToast(message, { appearance: "warning" });
  };

  return { successToast, errorToast, warningToast };
};

export default useToast;
